module.exports = __webpack_public_path__ + "static/img/references4.2dc7116.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/references4.jpg
// module id = z/WH
// module chunks = 1